import { reloadSaga } from "redux-sagas-injector";
import { createSharedStore } from "@p81-common/shell-core-js";
import rootSaga from "./rootSaga";
import rootReducer from "./rootReducer";

const store = createSharedStore({ rootReducer, rootSaga });

export default store;

if (module.hot) {
  module.hot.accept("./rootSaga", () => {
    reloadSaga("rootSaga", require("./rootSaga").default);
  });
}
